import React, { useContext, useEffect } from "react";
import { CapabilityContext } from "./context/CapabilityContext";
import { AssociateContext } from "../associate/context/AssociateContext";
import { getStationCode } from "../network/NetworkUtil";

import {
  getDocumentURL,
  getNodeCapability,
} from "../handler/ParentDataHandler";
import {
  getBaseUrl,
  parseCapabilitiesResponse,
} from "../outboundAmzl/util/Util";
import { MobileDisplay } from "../common/MobileDisplay";
import PageHeader from "../PageHeader";
import { PAGE_HEADERS } from "../util/Constants";
import RouteFilterWrapper from "./RouteFilterWrapper";
import RouteOverallStatus from "./RouteOverallStatus";
import AssociateDetailView from "../associate/AssociateDetailView";
import RouteStatusTable from "./RouteStatusTable";
import AlertView from "../outboundAmzl/AlertView";
import AlertContextProvider from "../outboundAmzl/context/AlertContext";
import {
  GET_CAPABILITIES,
  GET_STATION_CONFIG,
} from "./utils/ReducerActionTypes";

const RouteView = (props) => {
  const { configViewModel, configDispatch } = useContext(CapabilityContext);
  const { associateViewModel } = useContext(AssociateContext);
  const stationCode = getStationCode();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await Promise.all([
          getDocumentURL(),
          getNodeCapability(),
        ]);
        const model = {
          capability: parseCapabilitiesResponse(result[1]),
          baseUrl: getBaseUrl(result[0]),
        };
        configDispatch({ type: GET_CAPABILITIES, data: model });
        configDispatch({
          type: GET_STATION_CONFIG,
          data: {
            dispatcher: configDispatch,
            baseUrl: model.baseUrl,
          },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [configDispatch, stationCode]);

  return (
    <div>
      {configViewModel.capability !== "" &&
      configViewModel.stationConfig.initialised ? (
        <div>
          <MobileDisplay visibility={false}>
            <AlertContextProvider>
              <AlertView />
            </AlertContextProvider>
          </MobileDisplay>
          {associateViewModel.associate.length === 0 ? (
            <div>
              <PageHeader {...PAGE_HEADERS.ROUTE_STATUS} />
              <div>
                <RouteFilterWrapper />
                <RouteOverallStatus />
                <RouteStatusTable history={props.history} />
              </div>
            </div>
          ) : (
            <AssociateDetailView />
          )}
        </div>
      ) : null}
    </div>
  );
};

export default RouteView;



// WEBPACK FOOTER //
// ./src/components/RouteStatus/RouteView.js